import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '4px',
      height: '25px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      padding: '4px',
      height: '25px',
    },
    bodyCellRight: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'right',
      padding: '4px',
      height: '25px',
    },
    bodyCellLeft: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'left',
      padding: '4px',
      height: '25px',
    },
    bodyRow: {
      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: 'yellow',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },


    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '98%',
      borderBottom: '1px solid #000000',
      borderTop: 'none',
        borderLeft:'none',
        borderRight:'none',
      backgroundColor: 'transparent',
      textAlign: "center",
    },
  })
);

export const JudgeSettingStyle = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 300px)',
    },
    paper: {
      background: '#FFFFEE',
    },
    buttonStyle: {
      maxWidth: '200px',
      maxHeight: '35px',
      minWidth: '200px',
      minHeight: '35px',
    },
  })
);
